import { Injectable } from '@angular/core';
import { Anys } from '../../util/anys';
import { HttpStatusCode, HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class GestionErreurService {
  private readonly codeErreurGenerique = '[???]';
  private readonly codeErreurAucunCompteCredit = 'CAAD.400404';
  private readonly codeErreurAucuneCarteCredit = 'CAAD.400405';

  constructor() {}

  getStatus(err: HttpErrorResponse): number {
    return err.status;
  }

  getCodeErreur(err: HttpErrorResponse): string {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return err?.error?.errors?.find((e: any) => Anys.notNullOrUndef(e.code))?.code ?? this.codeErreurGenerique;
  }

  getMessageErreur(err: HttpErrorResponse): string {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return err?.error?.errors?.find((e: any) => Anys.notNullOrUndef(e.message))?.message ?? '';
  }

  doitAfficherPageAucuneCarteCredit(err: HttpErrorResponse): boolean {
    const status = this.getStatus(err);
    const codeErreur = this.getCodeErreur(err);
    return (
      status === HttpStatusCode.BadRequest &&
      (codeErreur === this.codeErreurAucunCompteCredit || codeErreur === this.codeErreurAucuneCarteCredit)
    );
  }
}
